import {FAILED_TO_GET_CASE_TYPES, GET_CASE_TYPES, RECEIVE_CASE_TYPES} from "./index";

//function that requests get case types
export function getCaseTypes() {
    return{
        type: GET_CASE_TYPES
    }
}

//function that receives the case types
export function receiveCaseTypes(caseTypes) {
    return {
        type: RECEIVE_CASE_TYPES,
        payload: caseTypes
    }
}

//function that receives failed response while getting the case types
export function failedToGetCaseTypes(response) {
    return {
        type: FAILED_TO_GET_CASE_TYPES,
        payload: response
    }
}